import { render, staticRenderFns } from "./LeaseRules.vue?vue&type=template&id=028829b9&scoped=true"
import script from "./LeaseRules.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaseRules.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LeaseRules.vue?vue&type=style&index=0&id=028829b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028829b9",
  null
  
)

export default component.exports